import {
  LinkCustomerPolicyBody,
  LinkCustomerPolicyResponses,
} from '@aaa-ncnu-ie/mypolicy-api-customers';

import axios from './axios';

export interface LinkCustomerPolicyArgs {
  lastFourDigits: string;
}

export const linkCustomerPolicy = async ({
  lastFourDigits,
}: LinkCustomerPolicyBody) => {
  const requestBody: LinkCustomerPolicyBody = { lastFourDigits };

  if (!requestBody) {
    return Promise.reject(new Error('Missing request body'));
  }

  const { data } = await axios.post<LinkCustomerPolicyResponses>(
    `${import.meta.env.VITE_CUSTOMERS_API_URL}/v1/customers/link-policy`,
    requestBody
  );

  return data;
};
